/** @jsxImportSource @emotion/react */
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Checkbox, Form, Modal } from "antd";
import { LoginFormType } from "api/auth/type";
import InputCustom from "components/base/InputCustom";
import InputPassword from "components/base/InputPassword";
import { REGEX_PASSWORD, REGEX_USERNAME } from "constants/regex";
import { ResponseCode } from "constants/response";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { selectIsLoading } from "store/auth";
import { signInWithCredentials } from "store/auth/auth.thunk";
import { setOpenModal } from "store/modal";
import { outletContextType } from "types";
import { ApiResponse } from "types/api";
import { ModalTypeValue } from "types/modal";
import * as yup from "yup";

import WrapperForm from "../WrapperForm";
import { LoginModalStyle } from "./index.style";

function LoginModal() {
  const { t } = useTranslation(["common", "login"]);
  const schema = yup
    .object({
      username: yup
        .string()
        // .trim()
        .matches(REGEX_USERNAME, t("login:username_validation"))
        .required(t("login:username_required")),
      // .string()
      // .min(10, t("login:Min"))
      // .max(14, t("login:Max"))
      // .trim()
      // .required(t("login:username_required")),
      password: yup
        .string()
        .trim()
        .matches(REGEX_PASSWORD, t("login:password_validation"))
        .required(t("login:password_validation"))
    })
    .required();
  const dispatch = useAppDispatch();
  const { openNotification } = useOutletContext<outletContextType>();
  const isLoading = useAppSelector(selectIsLoading);
  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors, isValid }
  } = useForm<LoginFormType>({
    resolver: yupResolver(schema),
    mode: "all"
  });
  const [isRememberMe, setIsRememberMe] = useState(false);

  const areaCodeValidate = (number: string) => {
    if (number.startsWith("+")) {
      number = number.slice(1);
    }
    if (number.startsWith("0")) {
      return "880" + number.slice(1);
    }

    if (number.slice(0, 3) !== "880") {
      return "880" + number;
    }
    return number;
  };

  function getCookie(name: string) {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [key, value] = cookie.split("=");
      if (key === name) return decodeURIComponent(value);
    }
    return null;
  }

  const onSubmit: SubmitHandler<LoginFormType> = async (
    data: LoginFormType
  ) => {
    const res = await dispatch(
      signInWithCredentials({
        ...data
      })
    );
    const resData = res.payload as ApiResponse;
    if (resData.status !== ResponseCode.SUCCESS) {
      openNotification("error", t("login:error_message"));
      return;
    }
    if (isRememberMe) {
      document.cookie = `username=${data.username}; path=/;`;
      document.cookie = `password=${data.password}; path=/;`;
    } else {
      document.cookie = "username=; max-age=0; path=/;";
      document.cookie = "password=; max-age=0; path=/;";
    }
    dispatch(setOpenModal(ModalTypeValue.Close));
  };

  // const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
  //   if (e.key === "e" || e.key === "E") {
  //     e.preventDefault();
  //   }
  // };

  useEffect(() => {
    const userName = getCookie("username");
    const password = getCookie("password");
    if (userName && password) {
      setTimeout(() => {
        setValue("username", userName);
        setValue("password", password, { shouldValidate: true });
      }, 100);
      setIsRememberMe(true);
    }
  }, []);
  console.log("valuesss", getValues());
  return (
    <Modal
      open={true}
      closable={false}
      forceRender
      onCancel={() => dispatch(setOpenModal(ModalTypeValue.Close))}
      css={LoginModalStyle.modalContainer}
      footer={<></>}
      centered
      focusTriggerAfterClose={false}
    >
      <WrapperForm
        title={t("login:title")}
        formType={ModalTypeValue.Login}
        body={
          <div css={LoginModalStyle.formContainer}>
            <Form
              css={LoginModalStyle.formContainer}
              onSubmitCapture={handleSubmit(onSubmit)}
              autoComplete="new-password"
            >
              <div css={LoginModalStyle.inputControl}>
                <label>{t("login:username_label")}</label>
                <InputCustom
                  disabled={isLoading}
                  placeholder={t("login:username_placeholder")}
                  name={"username"}
                  control={control}
                  margin_bottom="0px"
                  errors={errors.username?.message}
                  validate_status={errors.username ? "error" : "success"}
                  defaultValue={getCookie("username") || ""}
                />
              </div>
              <div css={LoginModalStyle.inputControl}>
                <label>{t("login:password_label")}</label>
                <InputPassword
                  disabled={isLoading}
                  placeholder={t("login:password_placeholder")}
                  name={"password"}
                  control={control}
                  margin_bottom="0px"
                  error={errors.password?.message}
                  validate_status={errors.password ? "error" : "success"}
                  id="login-password"
                  defaultValue={getCookie("password") || ""}
                />
              </div>
              <div css={LoginModalStyle.inputControl}>
                <Checkbox
                  checked={isRememberMe}
                  onChange={(e) => setIsRememberMe(e.target.checked)}
                >
                  {t("login:remember_me")}
                </Checkbox>
              </div>
              <span
                onClick={() =>
                  dispatch(setOpenModal(ModalTypeValue.ForgetPassword))
                }
                css={LoginModalStyle.forgetPass}
              >
                {t("login:forget_password")}
              </span>
              <Button
                disabled={!isValid}
                loading={isLoading}
                css={[
                  LoginModalStyle.buttonSubmit,
                  isValid && LoginModalStyle.buttonActive
                ]}
                htmlType="submit"
              >
                {t("login:submit_button")}
              </Button>
            </Form>
          </div>
        }
        footer={
          <div css={LoginModalStyle.footer}>
            <p>
              {t("login:no_account")}{" "}
              <span
                onClick={() => dispatch(setOpenModal(ModalTypeValue.Register))}
              >
                {t("login:signup")}
              </span>
            </p>
          </div>
        }
      />
    </Modal>
  );
}

export default LoginModal;
